import { PRODUCT_NAME } from '@/constants';
import type { Route } from 'next';
import type { Session } from 'next-auth';
import Link from 'next/link';
import styles from './CommonFooter.module.scss';

function CommonFooter({
  siteName,
  sessionData,
}: {
  siteName: string;
  sessionData?: Session | null;
}) {
  // toはサイト内リンク、hrefは外部リンク
  const menuListLeft = () => {
    const list = sessionData?.user
      ? [
          { to: '/auth/signin', text: 'ログイン・新規会員登録' },
          { to: '/lotteries?session=true', text: '開催中のくじ一覧' },
          { to: '/faq', text: 'よくある質問' },
          { to: '/contact', text: 'お問い合わせ' },
          { to: '/informations', text: 'お知らせ' },
        ]
      : [
          { to: '/auth/signin', text: 'ログイン・新規会員登録' },
          { to: '/lotteries?session=true', text: '開催中のくじ一覧' },
          { to: '/faq', text: 'よくある質問' },
          { to: '/informations', text: 'お知らせ' },
        ];
    return list;
  };
  const menuListRight = () => {
    return [
      { to: '/terms', text: '利用規約' },
      {
        href: 'https://fogg.jp/privacy',
        text: '個人情報保護方針',
      },
      {
        to: '/policy',
        text: '個人情報の取扱いについて',
      },
      { to: '/tokusho', text: '特定商取引法に基づく表記' },
      { to: '/shikin', text: '資金決済法に基づく表記' },
      { to: '/keihin', text: '景品のお取り扱いについての注意事項' },
    ];
  };
  return (
    <footer className={styles.componentStyle}>
      <div className={styles.container}>
        <div className={styles.footerTitle}>
          <img src='/logo-white.png' alt={siteName} />
        </div>
        <div className={styles.menuListWrapper}>
          <ul className={styles.menuList}>{menuList(menuListLeft())}</ul>
          <ul className={styles.menuList}>{menuList(menuListRight())}</ul>
        </div>
        <p className={styles.copyright}>Copyrights 2024 {PRODUCT_NAME} All Rights Reserved.</p>
      </div>
    </footer>
  );
}

function menuList(list: Array<{ href?: string; to?: string; text: string }>) {
  const result: Array<React.ReactNode> = [];
  list.forEach((item) => {
    result.push(
      <li key={item.href || item.to || item.text}>
        {item.href ? <a href={item.href}>{item.text}</a> : <Link href={item.to as Route}>{item.text}</Link>}
      </li>,
    );
  });

  return result;
}

export default CommonFooter;
